module.exports = __webpack_public_path__ + "img/l-cb6-010.dd63cf9e.gif";